import script from "./ImageGenerator.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageGenerator.vue?vue&type=script&lang=ts&setup=true"

import "./ImageGenerator.vue?vue&type=style&index=0&id=5a266582&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a266582"]])

export default __exports__